import './IconDesktop.css';


export default function IconDesktop ({onClick, image, p}) {

    return (
        <div className="continer-desktop-icon" onClick={() => onClick()}>
            <div>
                {p && <p> {p} </p>}
                {image && <img src={image} />}
            </div>
        </div>
    )
}